var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { APPEvent as AEvent, APPEvent } from "@/events/AppEvents";
import { MessageDeliveryStatus, MessageType, Text, LetrboxDocumentStatus, LetrboxDocument, LetrboxImage } from "@@/Message";
import { DateLib } from "@@/Datelib";
import { MessageUIRequest, MessageUIRequestType } from "@/share/Message";
import { Apphandler } from "@/ipc/MainAppHandler";
import { FileDownloadType } from "@/share/FileRequest";
import { LetrType } from "@@/Letr";
import { AccessGroupState } from "@/app/uistore/AccessgroupState";
import { CHATID } from "@@/Tags";
export var DownloadState;
(function (DownloadState) {
    DownloadState[DownloadState["Downloading"] = 0] = "Downloading";
    DownloadState[DownloadState["Downloaded"] = 1] = "Downloaded";
    DownloadState[DownloadState["Error"] = 2] = "Error";
})(DownloadState || (DownloadState = {}));
export class ImageDownloadState {
    constructor(path = "") {
        this.downloadstatus = DownloadState.Downloading;
        this.path = "";
        this.showmodal = false;
        this.progress = 0;
        this.downloadstarted = false;
        makeObservable(this);
        this.path = path;
        if (this.path) {
            this.setDownloadStatus(DownloadState.Downloaded);
        }
    }
    setDownloadStarted(started) {
        this.downloadstarted = started;
    }
    setDownloadStatus(st) {
        this.downloadstatus = st;
    }
    setProgress(pg) {
        this.progress = pg;
    }
    setPath(path) {
        this.path = path;
    }
    setShowModal(show) {
        this.showmodal = show;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], ImageDownloadState.prototype, "downloadstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ImageDownloadState.prototype, "path", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ImageDownloadState.prototype, "showmodal", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ImageDownloadState.prototype, "progress", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ImageDownloadState.prototype, "downloadstarted", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setDownloadStarted", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setDownloadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setProgress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setPath", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setShowModal", null);
export class MessageUIStore {
    constructor() {
        this.messages = new Map();
        this.messagesBySection = new Map();
        this.loading = false;
        this.loadingMore = false;
        this.activeletrid = "";
        this.lastMessageTime = 0; // maybe better to use server side lgic ?
        this.activeSection = "";
        this.clientwidth = 200;
        this.clientheight = 500;
        this.updatingSection = false;
        this.displaySection = "";
        this.renderedSections = new Set();
        this.lastCount = -1;
        this.messagecoutrequest = 15;
        this.showStickySection = false;
        this.repliesMap = new Map();
        this.edittingMessageId = "";
        this.editingHtml = "";
        this.savingedit = false;
        this.activetag = "";
        this.hidesystemmessages = true;
        this.imagesstate = new Map();
        this.downloadingfileids = new Map();
        this.letrtype = LetrType.Letr;
        this.appliedaclstr = "everyone";
        this.accessstorestate = new AccessGroupState();
        this.activeaccessids = new Set(["everyone"]);
        this.myid = "";
        this.myletr = false;
        this.gettingprojectitem = false;
        this.openactionmenu = false;
        this.getobjectid = "";
        makeObservable(this);
        APPEvent.addSubscriberForProjectObjectElem((res) => {
            var _a;
            if (this.gettingprojectitem && res.letrid === this.activeletrid &&
                this.getobjectid === res.objectid) {
                (_a = this.showobjectcb) === null || _a === void 0 ? void 0 : _a.call(this, res.object);
                this.setGettingProject(false);
            }
        });
        APPEvent.addSubscriberForDownload((res) => {
            const fileid = this.downloadingfileids.get(res.id);
            if (fileid === undefined) {
                return;
            }
            const istate = this.imagesstate.get(fileid);
            if (istate !== undefined && istate.downloadstatus === DownloadState.Downloading
                &&
                    res.requesttype === FileDownloadType.Download) {
                if (res.downloadpath !== undefined) {
                    const msg = this.getMessageById(fileid);
                    if (msg !== undefined && msg.type === MessageType.Image) {
                        let prefix = "data:image/png;base64,";
                        const name = msg.text;
                        if (name.indexOf(".") > 0) {
                            const ext = name.split('.').pop();
                            if (ext !== undefined) {
                                if (ext.toLowerCase() === 'jpg') {
                                    prefix = "data:image/jpg;base64,";
                                }
                                else if (ext.toLowerCase() === 'jpeg') {
                                    prefix = "data:image/jpeg;base64,";
                                }
                                else if (ext.toLowerCase() === 'gif') {
                                    prefix = "data:image/gif;base64,";
                                }
                                else if (ext.toLowerCase() === 'giff') {
                                    prefix = "data:image/giff;base64,";
                                }
                            }
                        }
                        res.downloadpath = prefix + res.downloadpath;
                    }
                    istate.setPath(res.downloadpath);
                    istate.setDownloadStatus(DownloadState.Downloaded);
                    istate.setDownloadStarted(false);
                }
                else if (res.downloadfailed) {
                    istate.setDownloadStatus(DownloadState.Error);
                    istate.setDownloadStarted(false);
                }
            }
        });
        AEvent.addSubscriberForMessageResponse((res) => {
            const msg = res.msg;
            const letrid = res.letrid;
            if (letrid === this.activeletrid) {
                if (res.type === MessageUIRequestType.Fetch) {
                    this.setLoading(false);
                    this.setLoadingMore(false);
                    if (msg.length < this.messagecoutrequest) {
                        this.setLastCount(0);
                    }
                    for (const m of msg) {
                        this.addMessage(m);
                    }
                }
                else if (res.type === MessageUIRequestType.Add) {
                    if (res.replaceId !== "" && this.messages.has(res.replaceId)) {
                        const pmsg = this.messages.get(res.replaceId);
                        if (pmsg !== undefined) {
                            this.removeMessage(pmsg._id);
                            this.addMessage(msg[0]);
                        }
                    }
                    else {
                        for (const m of msg) {
                            if ((m.type == MessageType.Project || m.type == MessageType.Note)
                                && this.hidesystemmessages) {
                                // ignore this
                            }
                            else {
                                this.addMessage(m);
                            }
                        }
                    }
                }
                else if (res.type === MessageUIRequestType.Edit) {
                    if (msg.length > 0) {
                        const pmsg = this.messages.get(res.replaceId);
                        if (pmsg !== undefined) {
                            this.removeMessage(pmsg._id);
                        }
                        this.addMessage(msg[0]);
                    }
                    this.setSavingEdit(false);
                    this.setEditMessageId("");
                }
                else if (res.type === MessageUIRequestType.AddReply && res.parentid) {
                    this.updateReplyCount(res.parentid, res.newcount);
                }
                else if (res.type === MessageUIRequestType.MessageUpdates) {
                    res.msg.forEach((msg) => this.messageAvaibale(msg));
                }
            }
        });
        AEvent.addSubscriberForActiveLetr((letrid) => {
            if (letrid !== this.activeletrid) {
                this.setActiveLetr(letrid);
                this.setHideSystemMessahe(true);
                this.letrChanged();
                if (this.activetag === CHATID) {
                    this.loadMessages();
                }
            }
        });
        AEvent.addSubscriberForDeleteMessageResponse((msg) => {
            const letrid = msg.letrid;
            if (letrid === this.activeletrid) {
                const tmsg = this.messages.get(msg._id);
                if (tmsg !== undefined) {
                    this.removeMessage(tmsg._id);
                }
            }
        });
        AEvent.addSubscriberDeleteReply((rmsg) => {
            const rcount = rmsg.replyCount != undefined ? rmsg.replyCount : 0;
            this.updateReplyCount(rmsg.parentid, rcount);
        });
        APPEvent.addSubscriberForActiveLetrObject((l) => {
            this.letrtype = l.letrtype;
            this.activeletrobj = l;
        });
        APPEvent.addSubscriberForUserID((id) => this.myid = id);
    }
    loadProjectObject(objectid) {
        const req = {
            objectid: objectid,
            letrid: this.activeletrid,
            origid: objectid
        };
        this.setGettingProject(true);
        this.getobjectid = objectid;
        Apphandler.sendMessage("getproject", req);
    }
    setGettingProject(get) {
        this.gettingprojectitem = get;
    }
    setOpenActionMenu(open) {
        this.openactionmenu = open;
    }
    setHideSystemMessahe(hide) {
        this.hidesystemmessages = hide;
    }
    updateReplyCount(msgid, newcount) {
        const msg = this.getMessageById(msgid);
        if (msg !== undefined) {
            if (msg.type === MessageType.Text) {
                const omsg = msg;
                const ntext = new Text(msg._id, msg.letrid, msg.user._id, msg.createdAt, msg.user, msg.text);
                ntext.setReplyCount(newcount);
                ntext.setstatus(MessageDeliveryStatus.Active);
                ntext.isHtml = omsg.isHtml;
                this.removeMessage(msgid);
                this.addMessage(ntext);
            }
        }
    }
    setAppliedAclString(str) {
        console.log(str + " applied");
        this.appliedaclstr = str;
    }
    selectAccessids(ids) {
        this.activeaccessids.clear();
        for (const id of ids) {
            this.addActiveAccessId(id);
        }
    }
    addActiveAccessId(id) {
        this.activeaccessids.add(id);
    }
    removeActiveAccessId(id) {
        this.activeaccessids.delete(id);
    }
    setShowStickySection(show) {
        this.showStickySection = show;
    }
    setEditMessageId(id) {
        if (this.savingedit) {
            return;
        }
        this.edittingMessageId = id;
        const msg = this.getMessageById(id);
        if (msg !== undefined) {
            this.setEditText(msg.text);
        }
        else {
            this.setEditText("");
        }
    }
    setEditText(text) {
        this.editingHtml = text;
    }
    setLastCount(count) {
        this.lastCount = count;
    }
    setSavingEdit(save) {
        this.savingedit = save;
    }
    saveEditMessage() {
        if (!this.edittingMessageId) {
            return;
        }
        const msg = this.getMessageById(this.edittingMessageId);
        if (msg === undefined || msg.type !== MessageType.Text) {
            return;
        }
        this.setSavingEdit(true);
        msg.text = this.editingHtml;
        msg.letrid = this.activeletrid;
        this.editMessage(msg);
    }
    setActiveLetr(id) {
        this.activeletrid = id;
    }
    letrChanged() {
        if (this.loading) {
            return;
        }
        this.resetMessages();
    }
    downloadImage(msg) {
        // lets download the image here and then we done for today!!
        const req = {
            letrid: this.activeletrid,
            id: msg.documentreference,
            requesttype: FileDownloadType.Download,
            size: msg.size,
            info: {
                name: "letrwing"
            },
            accesskey: msg.accesskey,
            boxid: msg.accesscode
        };
        this.downloadingfileids.set(msg.documentreference, msg._id);
        Apphandler.sendMessage("downloadfile", req);
    }
    getMessage(index) {
        return this.getMessages()[index];
    }
    getMessageById(id) {
        return this.messages.get(id);
    }
    removeMessage(id) {
        this.messages.delete(id);
    }
    setClientWidth(width) {
        this.clientwidth = width;
    }
    setClientHeight(height) {
        this.clientheight = height;
    }
    setDisplaySection(section) {
        this.displaySection = section;
    }
    async loadMessages() {
        if (!this.activeletrid || this.loading || this.loadingMore) {
            return;
        }
        this.setLoading(true);
        const req = new MessageUIRequest();
        req.letrid = this.activeletrid;
        req.count = this.messagecoutrequest;
        req.sortAsc = false;
        req.type = MessageUIRequestType.Fetch;
        if (this.hidesystemmessages) {
            req.excludetype.push(MessageType.Project);
            req.excludetype.push(MessageType.Note);
        }
        else {
            req.excludetype.push(MessageType.Text);
            req.excludetype.push(MessageType.Image);
        }
        req.time = new Date().getTime() + 60 * 60 * 24 * 1000;
        this.requestMessages(req);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setLoadingMore(lm) {
        this.loadingMore = lm;
    }
    addMessage(bmsg) {
        var _a;
        this.messages.set(bmsg._id, bmsg);
        const date = DateLib.getTodayOrFormatDate(bmsg.createdAt);
        if (!this.messagesBySection.has(date)) {
            this.messagesBySection.set(date, []);
        }
        (_a = this.messagesBySection.get(date)) === null || _a === void 0 ? void 0 : _a.push(bmsg);
        if (this.lastMessageTime === 0 || bmsg.createdAt < this.lastMessageTime) {
            this.lastMessageTime = bmsg.createdAt;
        }
    }
    createTextMessage(text, authorname, authorid) {
        const id = Math.random() + "";
        const tmessage = new Text(id, this.activeletrid, "", new Date().getTime(), { _id: authorid, name: authorname }, text);
        tmessage.isHtml = true;
        tmessage.setstatus(MessageDeliveryStatus.Activating);
        if (this.activeletrobj !== undefined && this.myid === this.activeletrobj.author) {
            tmessage.acl = this.appliedaclstr;
        }
        this.addMessage(tmessage);
        this.sendMessage(tmessage);
    }
    messageAvaibale(msg) {
        if (msg.letrid === this.activeletrid) {
            if (this.messages.has(msg._id)) {
                this.removeMessage(msg._id);
            }
            if ((msg.type === MessageType.Project || msg.type === MessageType.Note) && this.hidesystemmessages) {
                return;
            }
            this.addMessage(msg);
        }
    }
    sendImageMessage(file, authorname) {
        var _a, _b;
        const dmessage = new LetrboxImage(Math.random() + "", this.activeletrid, "", new Date().getTime(), { _id: "", name: authorname }, LetrboxDocumentStatus.Uploaded, file.size);
        dmessage.accesskey = file.accesskey;
        dmessage.accesscode = file.databoxid;
        dmessage.documentreference = file.fileid;
        dmessage.width = (_a = file.width) !== null && _a !== void 0 ? _a : 0;
        dmessage.height = (_b = file.height) !== null && _b !== void 0 ? _b : 0;
        if (this.activeletrobj !== undefined && this.myid === this.activeletrobj.author) {
            dmessage.acl = this.appliedaclstr;
        }
        this.addMessage(dmessage);
        this.sendMessage(dmessage);
    }
    sendDocumentmessage(file, authorname) {
        const dmessage = new LetrboxDocument(Math.random() + "", this.activeletrid, "", new Date().getTime(), { _id: "", name: authorname }, LetrboxDocumentStatus.Uploaded, file.filename);
        dmessage.accesskey = file.accesskey;
        dmessage.accesscode = file.databoxid;
        dmessage.documentreference = file.fileid;
        dmessage.size = file.size;
        dmessage.name = file.filename;
        dmessage.versions = [];
        dmessage.versions.push({
            name: file.filename,
            isDownloadable: file.isDownloadable,
            filid: file.fileid,
            boxid: file.databoxid,
            versionnumber: 1,
            acesskey: file.accesskey,
            size: file.size,
            creatorid: ''
        });
        if (this.activeletrobj !== undefined && this.myid === this.activeletrobj.author) {
            dmessage.acl = this.appliedaclstr;
        }
        this.addMessage(dmessage);
        this.sendMessage(dmessage);
    }
    sendMessage(msg) {
        const req = new MessageUIRequest();
        req.type = MessageUIRequestType.Add;
        req.letrid = this.activeletrid;
        req.replaceId = msg._id;
        req.msgs = msg;
        this.requestMessages(req);
    }
    getSections() {
        return this.messagesBySection;
    }
    getMessages() {
        return Array.from(this.messages.values()).sort(this.sortMessage);
    }
    loadMore() {
        if (this.loadingMore || this.loading) {
            return;
        }
        this.setLoadingMore(true);
        const req = new MessageUIRequest();
        req.letrid = this.activeletrid;
        req.count = this.messagecoutrequest;
        req.sortAsc = false;
        req.time = this.lastMessageTime;
        req.type = MessageUIRequestType.Fetch;
        if (this.hidesystemmessages) {
            req.excludetype.push(MessageType.Project);
        }
        this.requestMessages(req);
    }
    requestMessages(req) {
        Apphandler.sendMessage("messages", req);
    }
    getMessageSection(msg) {
        return DateLib.getTodayOrFormatDate(msg.createdAt);
    }
    getMessageTime(msg) {
        return DateLib.displayTime(msg.createdAt);
    }
    editMessage(msg) {
        if (this.messages.has(msg._id)) {
            const req = new MessageUIRequest();
            req.type = MessageUIRequestType.Edit;
            req.letrid = this.activeletrid;
            req.replaceId = msg._id;
            req.msgs = msg;
            this.requestMessages(req);
        }
    }
    deleteMessage(id) {
        const msg = this.getMessageById(id);
        if (msg === undefined) {
            return;
        }
        this.removeMessage(id);
        const req = new MessageUIRequest();
        req.type = MessageUIRequestType.Delete;
        req.letrid = this.activeletrid;
        req.replaceId = msg._id;
        req.msgs = msg;
        this.requestMessages(req);
    }
    deleteMessageOnUI(id) {
        const msg = this.getMessageById(id);
        if (msg === undefined) {
            return;
        }
        this.removeMessage(id);
    }
    resetMessages() {
        this.messages = new Map();
        this.messagesBySection = new Map();
        this.activeSection = "";
        this.updatingSection = false;
        this.setDisplaySection("");
        this.renderedSections = new Set();
        this.lastCount = -1;
        this.imagesstate = new Map();
        this.downloadingfileids = new Map();
    }
    reset() {
        this.resetMessages();
        this.setLoading(false);
        this.setActiveLetr("");
        this.setLoadingMore(false);
        this.activeaccessids = new Set(["everyone"]);
        this.appliedaclstr = "everyone";
    }
    sortMessage(m1, m2) {
        return m1.createdAt - m2.createdAt;
    }
    loadMoreReplies() {
        setTimeout(() => {
            for (let i = 0; i < 5; i++) {
                const letrid = Math.random() + '';
                const author = 'Test user';
                const date = new Date().getTime();
                const message = new Text(Math.random() + '', letrid, author, date, { '_id': author, 'name': 'Test user' }, i + ' Chakra UI is a simple, modular and accessible component library that gives you the building blocks you need to build your React applications. ' + i);
                this.repliesMap.set(letrid, message);
            }
        }, 500);
    }
    getMessageReplies() {
        return Array.from(this.repliesMap.values());
    }
    setDummyMessageData() {
        for (let i = 0; i < 5; i++) {
            const letrid = Math.random() + '';
            const author = 'Test user';
            const date = new Date().getTime();
            const message = new Text(Math.random() + '', letrid, author, date, { '_id': author, 'name': 'Test user' }, i + ' Chakra UI is a simple, modular and accessible component library that gives you the building blocks you need to build your React applications. ' + i);
            this.repliesMap.set(letrid, message);
        }
        for (let i = 0; i < 2; i++) {
            const letrid = Math.random() + '';
            const author = 'Test user';
            const date = new Date().getTime();
            const message = new LetrboxDocument(Math.random() + '', letrid, 'test string', date, { '_id': author, 'name': 'Test user' }, LetrboxDocumentStatus.Uploaded, 'TestDocument');
            this.repliesMap.set(letrid, message);
        }
        for (let i = 0; i < 2; i++) {
            const letrid = Math.random() + '';
            const author = 'Test user';
            const date = new Date().getTime();
            const message = new LetrboxDocument(Math.random() + '', letrid, 'test string', date, { '_id': author, 'name': 'Test user' }, LetrboxDocumentStatus.Uploading, 'TestDocumentUploading');
            this.repliesMap.set(letrid, message);
        }
        for (let i = 0; i < 2; i++) {
            const letrid = Math.random() + '';
            const author = 'Test user';
            const date = new Date().getTime();
            const message = new LetrboxImage(Math.random() + '', letrid, 'test string', date, { '_id': author, 'name': 'Test user' }, LetrboxDocumentStatus.Uploading, 1000);
            this.repliesMap.set(letrid, message);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], MessageUIStore.prototype, "messages", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], MessageUIStore.prototype, "messagesBySection", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "loadingMore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "activeletrid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "clientwidth", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "clientheight", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "displaySection", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "lastCount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "showStickySection", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], MessageUIStore.prototype, "repliesMap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "edittingMessageId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "editingHtml", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "savingedit", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "hidesystemmessages", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], MessageUIStore.prototype, "appliedaclstr", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], MessageUIStore.prototype, "activeaccessids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "gettingprojectitem", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageUIStore.prototype, "openactionmenu", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setGettingProject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setOpenActionMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setHideSystemMessahe", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "updateReplyCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setAppliedAclString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "selectAccessids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "addActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "removeActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setShowStickySection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setEditMessageId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setEditText", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setLastCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setSavingEdit", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setActiveLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "removeMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setClientWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setClientHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setDisplaySection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MessageUIStore.prototype, "loadMessages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setLoadingMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "addMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "resetMessages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MessageUIStore.prototype, "setDummyMessageData", null);
